<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import { mapGetters } from 'vuex';
 

 
 
  import CustomButton from '@/components/CustomButton';
  import Background from '@/components/Background';
  import TextFlowNumber from '@/components/TextFlowNumber';
  import TextFlowDropdown from './components/TextFlowDropdown';
  import TextFlowCard from './components/TextFlowCard';
  import TextFlowButton from './components/TextFlowButton';
  import AutoReplyModal from './components/AutoReplyModal';

  
  import TextFlowButtonIcon from './components/TextFlowButtonIcon';
  
import { ROUTE_TYPES, ACTION_TYPES } from '@/constants';
import { M_SET_TEXT_FLOW_TO_MENU, M_ONBOARDING_STEP } from '@/graphql';

  export default {
  name: 'TextMenu',
    props: {
      setsTarget: Function,
      setsTexts: Function,
      prevTarget: Function,
      noTarget: Number,
      prevTexts: Function
    },
  
  components: {
      AutoReplyModal,
    

      CustomButton,
      Background,
      TextFlowButtonIcon,
      TextFlowNumber,
      TextFlowCard,
      TextFlowButton,
      TextFlowDropdown
 
  },
   filters: {
      imgUrl(rowItem) {
        const imageName = rowItem === ACTION_TYPES.ACTION_PERSON ? 'person_white' : 'group_white';
        const images = require.context('@/assets/images', false, /\.svg$/);
        return images(`./${imageName}.svg`);
      }
    },

    watch: {
      clicked() {



        this.$nextTick(function () {

          if (this.clicked != 0) {
            this.showList = false;
          }

        });

      },
      noTarget() {
        this.clicked = -1
      }
    },

  data() {
      return {
        isLoading: false,
        autoReply: {
          enabled: false,
          replyText: ''
        },
        routes: [],
        hoverPerson: false,
        clicked: -1,
        hoverGroup: false,

        selectedItem: null,
        showList: false,
        disabled: false,
        btnDisabled: false,
        previous: {
          routes: [],
          autoReply: {
            enabled: false,
            replyText: ''
          }
        }
      };
    },
  
  computed: {
    ...mapGetters({
     
      userGroups: 'auth/getUserGroups',
      users: 'auth/getUserFullTeam',
      phoneName: 'onboarding/getSelectedName',
      phoneNumber: 'onboarding/getSelectedNumber',
      fullTeam: 'auth/getUserFullTeam',
      textFlow: 'onboarding/getSelectedTextFlow'
    }),
       displayAuto() {


        if  (this.routes && (this.routes.filter(e => !e.isEnabled)[0].routingType != "choose" ) ) 
        {

          return this.routes.filter(e=>!e.isEnabled)[0].keywords.length > 0 ? true : false
        }
        
        
     return false


      },
      name() {

        console.log(this.selectedData)
        if (this.type == "noassign") {
          return "Everyone"
        }

        return this.selectedData ? this.selectedData.target.name || this.selectedData.target.fullName : 'Choose';
      }
      ,
      choose() {
        return this.name == "Choose" ? "choose" : ""
      },
      type() {

        return this.routes.find(e => e.isEnabled) ? this.detectType(this.routes.find(e => e.isEnabled).routingType) : null
      },
      imgUrl() {
        const images = require.context('@/assets/images', false, /\.svg$/);
        return images('./' + (this.type ? (this.type != "noassign" ? this.type : "person") : "person") + '_white.svg');
      },


      isDefault() {
        if (!this.autoReply.enabled) {
          return true;
        }

        return false;

      },
      selectedData() {

        return this.routes.find(e => e.isEnabled)
      }
  ,
   
    groups() {
      return this.userGroups.filter((group) => group.isCreated === true);
    }
  },
  mounted() {

      console.log(this.textFlow.keyword_routing)

  

      if (this.textFlow.keyword_routing) {
        const { routes, auto_reply: autoReply, reply_msg: replyMsg } = JSON.parse(this.textFlow.keyword_routing);
        this.autoReply = {
          enabled: autoReply,
          replyText: replyMsg
        };




        this.routes = routes.map((route, index) => {
          return {
            key: Date.now() + index,
            keywords: route.keywords,
            routingType: route.user_id !== null ? ACTION_TYPES.ACTION_PERSON : (route.group_id != null ? ACTION_TYPES.ACTION_GROUP : "noassign"),
            isEnabled: route.keywords.length == 0 ? true : false,

            target:
              route.user_id !== null
                ? this.users.find((user) => route.user_id === user.id)
                : this.groups.find((group) => route.group_id === group.id)
          };
        });

        let currentItem = {}
        currentItem = this.routes.find(e => e.isEnabled);


        if (!currentItem || currentItem.length == 0) {


          this.routes.push({
            key: Date.now() + this.routes.length,
            keywords: [],
            routingType: "noassign",
            isEnabled: true,

            target: { type: "noassign" }
          });


        }

        console.log(currentItem)





        this.previous = {
          routes: JSON.parse(JSON.stringify(this.routes)),
          autoReply: { ...this.autoReply }
        };


        this.setsTexts(true, replyMsg)
        this.setsTexts(false, autoReply)


        this.prevTexts(true, replyMsg)

        this.prevTexts(false, autoReply)

        this.prevTarget(JSON.parse(JSON.stringify(this.routes)),
        )

        this.setsTarget(this.routes)
      }
      else
      {
             let currentItem = {}
        currentItem = this.routes.find(e => e.isEnabled);


        if (!currentItem || currentItem.length == 0) {


          this.routes.push({
            key: Date.now() + this.routes.length,
            keywords: [],
            routingType: "noassign",
            isEnabled: true,

            target: { type: "noassign" }
          });


        }

        console.log(currentItem)





        this.previous = {
          routes: JSON.parse(JSON.stringify(this.routes)),
      
        };


     
        this.prevTarget(JSON.parse(JSON.stringify(this.routes)),
        )

        this.setsTarget(this.routes)
      
      }
  },
  methods: {
      onSavePrevious() {
        this.previous = {
          routes: JSON.parse(JSON.stringify(this.routes)),
          autoReply: { ...this.autoReply }
        };
      },
      onDeleteRoute(index) {
        console.log(this.routes)



        this.routes = this.routes.filter(e => e.key != index)


        this.setsTarget(this.routes)
        console.log(this.routes)
      },
      /**
       * "Save" button click in the "Keywords" modal
       * @param route {object} - route object
       */
      saveKeywords(route = {}) {


        if (this.routes.find(e => e.key == route.key)) {

          this.routes = this.routes.map((item) => {
            if (item.key === route.key) {
              return {
                ...item,
                keywords: route.keywords
              };
            }
            return item;
          });



        }
        else {
          this.routes.push({
            key: Date.now(),
            keywords: route.keywords,
            routingType: "choose",
            isEnabled: false,

            target: {}
          });



        }

        console.log(route)



        this.setsTarget(this.routes)


        console.log("s")
        return this.routes;

      },
      /**
       * SMS Routing target selection
       * @param routingType {string} - type of the routing (route_person, route_group)
       * @param target {object} - target object
       */

      noContent() {
        this.showList = false;

      },





      setsClicked(dataId) {
        this.clicked = dataId;





      }
      ,


      onClickItem(item) {
        this.showList = false;
        this.$emit('onSelect', item);
      },
      onData() {
        console.log(this.type)
      },

      onClickItemData(item, data) {
        this.showList = false;
        this.hoverPerson = false;
        this.hoverGroup = false;


        this.selectRoutingTarget(item, data, this.type, 0, true)
      },
      switchLists(listType = '') {
        if (listType === 'person') {
          this.hoverGroup = false;
          return (this.hoverPerson = true);
        }
        this.hoverGroup = true;
        return (this.hoverPerson = false);
      }
      ,
      noDisplay() {
        this.hoverGroup = false;
        this.hoverPerson = false;




      },


      onShowList() {
        this.clicked = 0;


        this.showList = !this.showList;




      },




      selectRoutingTarget(routingType = '', target = {}, type, id, isEnabled = false) {
        if (routingType == "noassign") {
          target = { type: "noassign" }
        }

        this.setsTarget(this.routes)


        if (!isEnabled) {
          if (!type) {

            return this.routes.push({
              key: Date.now(),
              keywords: [],
              routingType,
              isEnabled: isEnabled,

              target: { ...target }
            });


          }
          else {
            console.log("ssss")
            this.routes = this.routes.map((item) => {
              if (item.key === id) {
                return {
                  ...item,
                  target: target,
                  routingType: routingType
                };
              }
              return item;
            });
            this.setsTarget(this.routes)



          }


        }
        else {
          const currentRoute = this.routes.find(e => e.isEnabled)


          if (!currentRoute) {

            return this.routes.push({
              key: Date.now(),
              keywords: [],
              routingType,
              isEnabled: isEnabled,

              target: { ...target }
            });

          }
          else {
            this.routes.find(e => e.isEnabled).routingType = routingType;
            this.routes.find(e => e.isEnabled).target = target;
            console.log("ssss")
            this.setsTarget(this.routes)

          }

        }


      },

      formatRoutes() {
        const formatted = this.routes.map((route) => {
          return {
            keywords: route.keywords,
            user_id: route.routingType === ACTION_TYPES.ACTION_PERSON ? route.target.id : null,
            group_id: route.routingType === ACTION_TYPES.ACTION_GROUP ? route.target.id : null
          };
        });
        return formatted;
      },

      async updateSMSRouting() {
        try {
          this.isLoading = true;
          if (this.autoReply.enabled) {
            this.routes = this.routes.filter(e => !e.isEnabled)
          }
          const textMenu = {
            routes: this.formatRoutes(),
            auto_reply: this.autoReply.enabled,
            reply_msg: this.autoReply.replyText
          };

          this.onSavePrevious();

          await this.$apollo.mutate({
            mutation: M_SET_TEXT_FLOW_TO_MENU,
            variables: {
              phoneNumberId: this.phoneNumber.id,
              textMenu: JSON.stringify(textMenu)
            },
            update: (cache, { data: { update_textflows } }) => {

              this.$toast.success('Changes saved', {
                position: 'top-right',
                timeout: 3000,
                hideProgressBar: true
              });
              try {
                const phone_numbers = this.phoneNumbers;
                const updatedFlow = update_textflows.returning[0];
                const updatedPhoneNumbers = phone_numbers.map((phoneNumber) => {
                  if (phoneNumber.id === this.phoneNumber.id) {
                    return {
                      ...phoneNumber,
                      textflow: updatedFlow
                    };
                  }
                  return phoneNumber;
                });

                cache.writeQuery({
                  query: Q_PHONE_NUMBERS,
                  data: { phone_numbers: updatedPhoneNumbers }
                });

                this.$store.dispatch('main/setPhoneNumbers', {
                  phoneNumbers: updatedPhoneNumbers
                });
              } catch (e) {
                console.log(e);
              }
            }
          });

          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          this.$toast.error('Failed to save changes', {
            position: 'top-right',
            timeout: 3000,
            hideProgressBar: true
          });
          console.log('SMS ROUTING -> MENU: ERROR\n', error);
        }
      },

      handleAutoReplyInput(value = '') {
        this.autoReply.replyText = value;
        this.setsTexts(true, value)
      },

      switchAutoReply(value = false) {

        this.autoReply.enabled = value;
        this.setsTexts(false, value)
      },

      detectData(routingType) {
        return (routingType === ACTION_TYPES.ACTION_PERSON && this.users) || this.groups;
      },
      /**
       * Detect routing type of the route (person, group)
       * @param routingType {string} - routing type (route_person, route_group)
       * @returns {string}
       */
      detectType: (routingType) => {
        console.log(routingType)

        if (routingType == "noassign" || !routingType) {
          return "noassign"
        }
        else {
          if (routingType == "choose") { return "choose" }



          return (routingType === ACTION_TYPES.ACTION_PERSON && 'person') || 'group'
        }





      }
    }
 
};
</script>
